import React from "react"
import PropTypes from "prop-types"
import { Form, SubmitButton, Spacer } from "../forms"
import Fieldset from "./fieldset"

const ApplicationForm = ({
  id,
  name,
  fieldsets,
  formState,
  handleInputChange,
  handleSubmit,
  submitting,
  customFieldComponents,
  simpleForm,
  handleRemoveVideo
}) => (
  <Form simpleForm={simpleForm}>
    {fieldsets
      .filter((fieldset) => fieldset.fields.length > 0)
      .map((fieldset, index) => (
        <>
          <Fieldset
            key={`${name}_${fieldset.name}`}
            {...fieldset}
            formState={formState}
            handleInputChange={handleInputChange}
            customFieldComponents={customFieldComponents}
            simpleForm={simpleForm}
            last={index + 1 == fieldsets.length}
            handleRemoveVideo={handleRemoveVideo}
          />
          {simpleForm && index + 1 < fieldsets.length && <Spacer />}
        </>
      ))}
    <SubmitButton handleClick={handleSubmit} disabled={submitting} simpleForm={simpleForm} />
  </Form>
)

ApplicationForm.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  fieldsets: PropTypes.array.isRequired,
  formState: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  customFieldComponents: PropTypes.object
}

ApplicationForm.defaultProps = {
  fieldsets: [],
  formState: {},
  handleInputChange: undefined,
  handleSubmit: undefined,
  customFieldComponents: {}
}

export default ApplicationForm
